import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./componentes/Header";
import MainContent from "./componentes/MainContent";
import Footer from "./componentes/Footer";

import {
  HeroPrincipal,
  HeroAboutUs,
  HeroBlog,
  HeroBooks,
  HeroInformation,
  HeroByFilter,
} from "./componentes/Hero";

import FilterBy from "./endpoints/FilterBy";
import AboutUs from "./endpoints/AboutUs";
import Blog from "./endpoints/Blog";
import Article from "./endpoints/Article";
import Books from "./endpoints/Books";

const Information = lazy(() => import("./endpoints/Information"));
const App = () => {
  return (
    <Router>
      <main className="app-container" role="main">
        <Header />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <HeroPrincipal />
                <MainContent />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <HeroAboutUs />
                <AboutUs />
              </>
            }
          />
          <Route
            path="/blog"
            element={
              <>
                <HeroBlog />
                <Blog />
              </>
            }
          />
          <Route
            path="/information"
            element={
              <>
                <HeroInformation />
                <Suspense>
                  <Information />
                </Suspense>
              </>
            }
          />
          <Route
            path="/blog/:id"
            element={
              <>
                <HeroBlog />
                <Article />
              </>
            }
          />
          <Route
            path="/filterBy/:idTipo/:idNombre"
            element={
              <>
                <HeroByFilter />
                <FilterBy />
              </>
            }
          />
          <Route
            path="/books"
            element={
              <>
                <HeroBooks />
                <Books />
              </>
            }
          />
        </Routes>
        <Footer />
      </main>
    </Router>
  );
};

export default App;
